module.exports = __webpack_public_path__ + "static/media/production.0fe7bbba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/production.svg
// module id = 806
// module chunks = 0